import { I18N } from "oc-I18N";
import { CameraOnSvg } from "../../inlinesvgs/CameraOnSvg";
import { useLocalStorage } from "oc-ui/react/useLocalStorage";

const buttonTitle = I18N("Automatische Kameraführung An/Aus");

export function AutoCameraToggle() {
  let [isAutoCameraOn, setIsAutoCameraOn] = useLocalStorage("isAutoCameraOn", true);
  const on = isAutoCameraOn ? "on" : "off";
  return (
    <button
      className={`svg-button-dotted auto-cam-button active ${on}`}
      title={buttonTitle}
      aria-label={buttonTitle}
      data-button-key={`auto-camera-${on}`}
      onClick={() => {
        isAutoCameraOn = !isAutoCameraOn;
        setIsAutoCameraOn(isAutoCameraOn);
        APP.logUserAction(
          {
            action: "toggleAutoCameraButton",
            isAutoCameraOn,
          },
          { stateChange: false }
        );
        APP.updateUI();
      }}
    >
      <CameraOnSvg />
    </button>
  );
}
